import LinearProgress from "@material-ui/core/LinearProgress";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { inject, observer } from "mobx-react";
import React from "react";
import { CommonsStore } from "../../model/CommonsStore";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    }
  });

export interface LinearBufferProps extends WithStyles<typeof styles> {
  commons?: CommonsStore;
}

@inject("commons")
@observer
class LinearBufferComponent extends React.Component<LinearBufferProps> {
  public show = false;

  public render() {
    if (this.props.commons) {
      this.show = this.props.commons.dataExchange;
    }
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {this.show ? <LinearProgress color="primary" /> : <></>}
      </div>
    );
  }
}

export const LinearBuffer = withStyles(styles, { withTheme: true })(
  LinearBufferComponent
);
